import { Button, Modal, Box, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "../../../hooks/useTranslation";
import printJS from "print-js";
interface ShippingLabelProps {
  open: boolean;
  onClose: () => void;
  labelUrl: string;
}

export const ShippingLabel = ({
  labelUrl,
  open,
  onClose,
}: ShippingLabelProps) => {
  const { translate } = useTranslation("buttons");

  const handlePrint = () => {
    printJS({
      printable: labelUrl,
      type: "image",
      style:
        "img { max-width: 100%; height: auto; margin: 0 auto; display: block; }",
    });
  };

  const handleDownload = () => {
    window.open(labelUrl, "_blank");
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          maxWidth: "90vw",
          maxHeight: "90vh",
          overflow: "auto",
          borderRadius: 2,
        }}
      >
        <Stack direction="row" justifyContent="flex-end" mb={1}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img
            src={labelUrl}
            alt="Shipping Label"
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              border: "1px solid #ccc",
            }}
          />
        </Box>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={handleDownload}>
            {translate("openInNewTab")}
          </Button>
          <Button variant="contained" onClick={handlePrint}>
            {translate("print")}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
